import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Rx from 'rxjs';
import { AppSettingService } from '../app.service';
import { CacheService } from '../utility/cache.service';

export interface IZipCodeLocation {
	City: string,
	CountryCode: string,
	Latitude: number,
	Longitude: number,
	StateCode: string,
	StateName: string,
	Street: string,
	ZipCode: string
};

@Injectable({
	providedIn: 'root'
})
export class ZipCodeAPIService {
	constructor(
		private http: HttpClient
	) { }
	private url = AppSettingService.appConfig.JourneyAPIUrl + "ZipCode";

	getLocation(zipCode: string): Rx.Observable<IZipCodeLocation> {
		return this.http.get<any>(
			this.url + "/" + encodeURIComponent(zipCode) 
		);
	}

	getLocationByIP(ip: string = ""): Rx.Observable<IZipCodeLocation> {
		return this.http.get<any>(
			this.url + "/IP?ip=" + encodeURIComponent(ip)
		);
	}
}


export interface ICityState {
	City: string;
	State: string;
}

@Injectable({
	providedIn: 'root'
})
export class StateAPIService {
	constructor(
		private cacheSrv: CacheService,
		private http: HttpClient
	) { }

	private url = AppSettingService.appConfig.JourneyAPIUrl + "State";

	getAllStates(): Rx.Observable<any> {
		let l: string = this.url + "/All";
		return this.cacheSrv.get(true, l);
	}

	lookupCityState(keyword: string, limit: number): Rx.Observable<ICityState[]> {
		return this.http.get<any>(
			this.url + "/City/Lookup?keyowrd=" + encodeURIComponent(keyword) + "&limit=" + limit.toString()
		);
	}
}

